var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{class:{ dark_btn: _vm.color === 'dark' },attrs:{"color":_vm.color,"disabled":_vm.disabled,"loading":_vm.loading},on:{"click":_vm.onClick}},[_c('v-icon',[_vm._v(_vm._s(_vm.icon))]),_vm._v(" "+_vm._s(_vm.text)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }